import React from 'react';
import { observer } from 'mobx-react-lite';
import { gameStore } from '../../../store/gameStore';
import { doBetStore } from '../../../store/doBetStore';
import ReBet from '../../reBet';
import BetItem from '../../betItem';

const WebScene = observer(
  ({
    isOpenBetPopup,
    totalBetForNote,
    setIsOpenBetPopup,
    setTotalBetForNote,
    isOpenCashOutPopup,
    setIsOpenCashOutPopup,
  }) => {
    const {
      pigs,
      sendCashOut,
      setBetAmount,
      betAmountPopupId,
      setAutoCashOutOdd,
      setBetAmountPopupId,
      autoCashOutQuickOdds,
      autoCashOutOddPopupId,
      setAutoCashOutOddPopupId,
      setIsNexRoundAutoCashOut,
    } = doBetStore;
    const { isBetsClosed } = gameStore;
    return (
      <div className='c-m-actions'>
        <div className='c-m-bets-wrapper'>
          <div className='c-m-bets-inner'>
            {pigs.map(
              (
                {
                  id,
                  betId,
                  isSave,
                  freeBetId,
                  freeBetMinOdd,
                  betAmount,
                  winAmount,
                  isDisabled,
                  isBetAccepted,
                  autoCashOutOdd,
                  isNextRoundBet,
                  isNextRoundAutoCashOut,
                },
                index
              ) => {
                return (
                  <div className='c-m-bets-column' key={id}>
                    <BetItem
                      key={index}
                      itemId={id}
                      betId={betId}
                      isSave={isSave}
                      betAmount={betAmount}
                      winAmount={winAmount}
                      freeBetId={freeBetId}
                      freeBetMinOdd={freeBetMinOdd}
                      isDisabled={isDisabled}
                      sendCashOut={sendCashOut}
                      isBetsClosed={isBetsClosed}
                      setBetAmount={setBetAmount}
                      isBetAccepted={isBetAccepted}
                      isOpenBetPopup={isOpenBetPopup}
                      autoCashOutOdd={autoCashOutOdd}
                      isNextRoundBet={isNextRoundBet}
                      totalBetForNote={totalBetForNote}
                      betAmountPopupId={betAmountPopupId}
                      setIsOpenBetPopup={setIsOpenBetPopup}
                      setAutoCashOutOdd={setAutoCashOutOdd}
                      isOpenCashOutPopup={isOpenCashOutPopup}
                      setTotalBetForNote={setTotalBetForNote}
                      setBetAmountPopupId={setBetAmountPopupId}
                      autoCashOutQuickOdds={autoCashOutQuickOdds}
                      setIsOpenCashOutPopup={setIsOpenCashOutPopup}
                      autoCashOutOddPopupId={autoCashOutOddPopupId}
                      isNextRoundAutoCashOut={isNextRoundAutoCashOut}
                      setAutoCashOutOddPopupId={setAutoCashOutOddPopupId}
                      setIsNexRoundAutoCashOut={setIsNexRoundAutoCashOut}
                    />
                  </div>
                );
              }
            )}
          </div>
        </div>
        <ReBet />
      </div>
    );
  }
);

export default WebScene;
